module.exports = __webpack_public_path__ + "static/media/taggis-website-card-preview.22256b57.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/taggis-website-card-preview.png
// module id = 376
// module chunks = 3